<template>
  <div class='sub-page'>
    <div class='sub-tab-wrap'>
      <DxTabPanel
          id="tabpanel"
          :selected-index.sync="selectedIndex"
          :data-source='tabs'
          :focusStateEnabled='true'
        >
        <template #title="{ data: tab }">
        <div class='sub-title-wrap-tab'>
          <ul>
            <li class='float-left sub-title'>{{tab.title}}</li>
          </ul>
          </div>
        </template>
      </DxTabPanel>
    </div>

    <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
      <div class="line-status-wrap">
        <div v-for='(item, index)  in lineinfoList' :key="index">
          <LineStatusComponent class="float-left" :lineInfo="item" @selected-line="onSelectedLine"/>
        </div>
      </div>
      <div class="fault-data-grid" style="margin-top:10px;">
        <dx-data-grid ref='refLineStatus'
          :data-source='machineFaultInfoList'
          :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
          :hover-state-enabled = "true" :allowColumnResizing = 'true'
          column-resizing-mode = 'widget' :allow-column-reordering = "true"
          :height='gridHeight' :row-alternation-enabled="true"
          :focused-row-enabled="true"
          :auto-navigate-to-focused-row="false"
          :focused-row-key.sync='focusedRowKey'
          key-expr="seqId"
          @cell-prepared='onCellPrepared'
          @row-updated='onRowUpdated' @row-updating="onRowUpdating"
        >
          <DxSearchPanel
            :visible="true"
            placeholder="검색..."
          />
          <DxExport
            :enabled="true"
            :file-name="exportTitle"
          />
          <DxFilterRow
            :visible="true"
            apply-filter="auto"
          />
          <DxEditing
            :allow-deleting="false"
            :allow-updating="true"
            :allow-adding="false"
            :use-icons="true"
            mode='popup'
          >
            <DxPopup
              :show-title="true"
              :width="700"
              :height="320"
              title="수리결과 등록"
            >
              <dx-position
                my="center"
                at="center"
                of="window"
              />
            </DxPopup>
            <DxForm>
              <DxItem
                :col-count="2"
                :col-span="2"
                item-type="group"
              >
                <DxItem data-field="접수일자"/>
                <DxItem data-field="라인명"/>
                <DxItem data-field="설비명"/>
                <DxItem data-field="고장시간"/>
                <DxItem data-field="수리완료시간"/>
                <DxItem data-field="계통코드"/>
                <DxItem data-field="고장유형코드"/>
                <DxItem data-field="고장내역"/>
              </DxItem>
              <DxItem
                :col-count="1"
                :col-span="2"
                item-type="group"
              >
                <DxItem data-field="수리내역"/>
              </DxItem>
            </DxForm>
          </DxEditing>
          <DxColumnFixing :enabled="true"/>
          <DxColumn
            :allowEditing='false'
            :fixed="true"
            caption="고장접수일"
            data-field="접수일자"
            dataType='datetime'
            sort-order='desc'
            format='yyyy-MM-dd HH:mm'>
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            :fixed="true"
            caption="라인명"
            data-field="라인명"
            :visible='true'
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            :fixed="true"
            caption="설비명"
            data-field="설비명"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            :fixed="true"
            caption="설비코드"
            data-field="설비코드"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="고장발생시간"
            data-field="고장시간"
            dataType='datetime'
            format='yyyy-MM-dd HH:mm'>
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="수리완료시간"
            data-field="수리완료시간"
            dataType='datetime'
            format='yyyy-MM-dd HH:mm'>
            <dx-required-rule message="항목을 선택하세요"/>
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="고장계통"
            data-field="계통코드"
            :visible='true'
          >
            <dx-required-rule message="항목을 선택하세요"/>
            <DxLookup
              :data-source="faultDefineLookup"
              display-expr="코드명"
              value-expr="코드"
            />
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="고장유형"
            data-field="고장유형코드"
            :visible='true'
          >
            <dx-required-rule message="항목을 선택하세요"/>
            <DxLookup
              :data-source="faultTypeLookup"
              display-expr="코드명"
              value-expr="코드"
            />
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="고장내역"
            data-field="고장내역"
            :visible='true'
          >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="수리내역"
            data-field="수리내역"
            :visible='true'
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="신고자"
            data-field="createid"
            :visible='true'
          >
          </DxColumn>
          <DxSummary>
            <DxTotalItem
              value-format='#,##0'
              column="접수일자"
              display-format="{0} (건)"
            />
          </DxSummary>
          <dx-paging :enabled="false"/>
          <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
          <dx-sorting mode="multiple"/>
        </dx-data-grid>
      </div>
    </div> <!--sub-conten end-->
    <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import DxTabPanel from 'devextreme-vue/tab-panel'
import ConstDef from '../../share/ConstDef'
import AppLib from '../../share/AppLib'
import DxDataGrid, { DxPopup, DxEditing, DxScrolling, DxFilterRow, DxColumnFixing, DxTotalItem, DxLookup,
  DxPosition, DxSummary, DxColumn, DxPaging, DxSorting, DxSearchPanel, DxExport, DxForm } from 'devextreme-vue/data-grid'
import { DxItem } from 'devextreme-vue/form'
import { DxRequiredRule } from 'devextreme-vue/validator'
import LineStatusComponent from '../../share/component/LineStatusComponent'
import axios from 'axios'
import SockJS from 'sockjs-client'
import Stomp from 'webstomp-client'

export default {
  name: 'login',
  data: function () {
    return {
      isLoading: false,
      userInfo: null,
      gridHeight: null,
      selectedIndex: 0,
      tabs: [
        {
          title: '라인가동현황'
        }
      ],
      machineFaultInfoList: null,
      exportTitle: '설비고장현황',
      faultDefineLookup: null,
      faultTypeLookup: null,
      lineinfoList: null,
      focusedRowKey: null,
      timerId: null,
      // STOMP
      connected: false,
      stompClient: null,
      socket: null
    }
  },
  components: {
    Loading,
    DxTabPanel,
    DxDataGrid,
    DxPopup,
    DxEditing,
    DxScrolling,
    DxFilterRow,
    DxColumnFixing,
    DxTotalItem,
    DxLookup,
    DxPosition,
    DxSummary,
    DxColumn,
    DxPaging,
    DxSorting,
    DxSearchPanel,
    DxExport,
    DxForm,
    DxItem,
    DxRequiredRule,
    LineStatusComponent
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
      return
    }
    this.faultDefineLookup = this.$store.getters.getBaseDataByType(ConstDef.고장계통)
    this.faultTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.고장유형)
    this.refreshFaultList()
  },
  mounted () {
    this.gridHeight = (screen.height - 760) * 0.95
    this.connect()
    this.setTimer()
  },
  updated () {
  },
  beforeDestroy: function () {
    this.disconnect()
    if (this.timerId !== null) clearTimeout(this.timerId)
  },
  methods: {
    onSelectedLine (seqId) {
      this.focusedRowKey = seqId
    },
    onCellPrepared  (e) {

    },
    onRowUpdated (row) {
      console.log(row.data)
      row.data.updateid = this.userInfo.userName
      row.data.updatetime = AppLib.getNow()
      if (row.data.수리완료시간 !== null && (typeof row.data.수리완료시간) === 'object') {
        row.data.수리완료시간 = row.data.수리완료시간.getTime()
      }
      this.$_sp.runUpdateSqlProc('설비고장', ['seqId'], ['createid', 'createtime', '라인명', '설비명'], [row.data])
        .then((date) => {
          this.$snotify.info('수리내역은 설비수리 현황에서 확인 할 수 있습니다.')
          this.refreshFaultList()
        })
    },
    onRowUpdating (row) {

    },
    refreshFaultList () {
      const line = this.$_sp.runNoEncodeFindProc('spFindAllLineStatue', {})
      const status = this.$_sp.runNoEncodeFindProc('spFindAllMachineFault', {})
      axios.all([line, status])
        .then(axios.spread((...reponse) => {
          this.lineinfoList = this.$_sp.MakeModel(reponse[0])
          this.machineFaultInfoList = this.$_sp.MakeModel(reponse[1])
        }))
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    setTimer () {
      this.timerId = setTimeout(() => {
        console.log('onTimer')
        this.onTimer()
      }, 60 * 60 * 1000)
    },
    onTimer () {
      this.disconnect()
      location.reload()
    },
    // stomp ***********
    connect (param) {
      this.socket = new SockJS(ConstDef.stompUrl)
      // const options = { debug: true, protocols: Stomp.VERSIONS.supportedProtocols() }
      this.stompClient = Stomp.over(this.socket)
      this.stompClient.connect(
        {},
        frame => {
          this.connected = true
          console.log(frame)
          this.stompClient.subscribe('/topic/machineFault', tick => {
            console.log(tick)
            this.refreshFaultList()
          })
        },
        error => {
          console.log(error)
          this.connected = false
        }
      )
    },
    disconnect () {
      if (this.stompClient) {
        this.stompClient.disconnect()
      }
      this.connected = false
    }
  }
}
</script>

<style lang="scss">
.line-status-wrap {
  height: 500px;
  padding: 10px;
  border: 4px solid rgb(230, 230, 230);
  border-style:groove;
  border-radius: 10px;
}
</style>
